import React, { useState, useCallback } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  Button,
  IconButton,
  TextField,
  MenuItem,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  RadioGroup,
  FormControlLabel,
  InputAdornment,
  ListItemText,
  Radio,
  Paper,
  debounce,
  useMediaQuery,
  ListItemIcon,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SettingsIcon from "@mui/icons-material/Settings";
import InputField from "../../../components/formElements/InputField";
import { API, graphqlOperation } from "aws-amplify";

import { showSuccessSnackbar } from "../../../components/snackBar/snakbar";
import { useDispatch, useSelector } from "react-redux";
import { grey } from "@mui/material/colors";
import { AddBox } from "@mui/icons-material";
import AddHSNModal from "./AddHSNModal";
import {
  createAccountGSTDetails,
  createAccountMaster,
  listAccountMasterv2Custom,
  searchHSN,
} from "../../../graphql";
import { useListGroupMasterQuery } from "../../../redux/apis/accountGroupMaster.api";
import {
  useCreateAccountMasterMutation,
  useListAccountMasterv2Query,
} from "../../../redux/apis/accountMaster.api";
import { useThemes } from "../../../components/Theme/theme";
import UseHSNMaster from "../Components/UseHSNMaster";
import useSaveShortcut from "../../../hooks/useSaveShortcut";
import useSaveModalShortcut from "../Components/useSaveModalShortcut";
import { dashboardApi } from "../../../redux/apis/dashboardApi";
import GroupModal from "../../../features/AccountsAndGroups/components/Groups/GroupModal";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  // p: 4,
  outline: "none",
  // minWidth: "500px",
  // "@media (min-width:600px)": {
  //   width: "auto",
  // },
  width: {xs:'90%',sm:"40%"},
};
function AddItemsAccountModal({
  open,
  setOpen,
  setData,
  data,
  accountType,
  setAllAccount,
  setAccNames,
  setNewAccID,
}) {
   const dispatch = useDispatch();
  const { theme } = useThemes();
    const { filterHSN, setFilterHSN, searchHSNDetails, HSNListboxProps, setRow } = UseHSNMaster({ Type: "",Page:"NONITEM" });
  const isSmallDvce = useMediaQuery(theme.breakpoints.down("sm"));
  const [openHsnModal, setOpenHsnModal] = useState(false);
  const [ledger, setLedger] = useState([]);
  const [group, setGroup] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [accountTypeCD, setAccountTypeCD] = useState("PandL");
    const [openGroupModal,setOpenGroupModal]=useState(false);
  const [state, setState] = useState({
    group:accountType==="Purchase"?  {label: "Purchases", value: 21, accountTypeCD: "PandL" }:{label: "Sales", value: 19, accountTypeCD: "PandL" },
    name: "",
    hsnCode: { label: "", value: "" },
    gstrate: "",
    cess: "",
    cessType: "",
    errorStatus: {
      group: false,
      name: false,
      hsnCode: false,
      gstrate: false,
      cess: false,
      cessType: false,
    },
    errorFields: {
      group: "",
      name: "",
    },
  });
  const handleClose = (event, reason) => {
    setState((prev) => ({
      ...prev,
      name: "",
      group:accountType==="Purchase"?  {label: "Purchases", value: 21, accountTypeCD: "PandL" }:{label: "Sales", value: 19, accountTypeCD: "PandL" },
      hsnCode: { label: "", value: "" },
      gstrate: "",
      cess: "",
      cessType: "",
      errorStatus: {
        ...prev.errorStatus,
        name: false,
        group: false,
        hsnCode: false,
        gstrate: false,
        cess: false,
        cessType: false,
      },
      errorFields: {
        ...prev.errorFields,
        name: "",
        group: "",
        hsnCode: "",
        gstrate: "",
        cess: "",
        cessType: "",
      },
    }));

    setOpen(false);
  };
  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "name") {
      value = value
        ?.toLowerCase()
        .replace(/\b\w/g, (match) => match.toUpperCase());
    }
    if (value == "") {
      setState((prev) => ({
        ...prev,
        name: value,
        errorStatus: {
          ...prev.errorStatus,
          name: true,
        },
        errorFields: {
          ...prev.errorFields,
          name: name + " is Required",
        },
      }));
    } else {
      setState((prev) => ({
        ...prev,
        name: value,
        errorStatus: {
          ...prev.errorStatus,
          name: false,
        },
        errorFields: {
          ...prev.errorFields,
          name: "",
        },
      }));
    }
  };
  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };

    Object.keys(data).map((key) => {
      if (key === "name") {
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.name = "Account Name is required";
          obj.errorStatus.name = true;
        } else {
          let uniqueValid = true;
          ledger.map((item) => {
            if (item.accountname?.toLowerCase() == state?.name?.toLowerCase()) {
              uniqueValid = false;
            }
          });
          if (uniqueValid == false) {
            isvalid = false;
            obj.errorFields.name = "Account Name already exists";
            obj.errorStatus.name = true;
          } else {
            obj.errorFields.name = "";
            obj.errorStatus.name = false;
          }
        }
      }
      if (key === "group") {
        if (data[key].value == 0) {
          isvalid = false;
          obj.errorFields.group = "Group is required";
          obj.errorStatus.group = true;
        } else {
          obj.errorFields.group = "";
          obj.errorStatus.group = false;
        }
      }
    });
    setState(obj);
    return isvalid;
  }
  function comparePathWithId(pathString, ...ids) {
    const pathArray = pathString?.replace(/^\/|\/$/g, "").split("/");
    const pathWithoutAccountId = pathArray?.slice(0, -1);

    return ids.some((id) => pathWithoutAccountId?.includes(id.toString()));
  }
  const [
    createAccountMaster,
    {
      isLoading: isCreatingAccount,
      isError: isCreateAccountError,
      isSuccess: isCreateAccountSuccess,
      error: createAccountError,
    },
  ] = useCreateAccountMasterMutation();
  // async function listLedgerData() {
  //   try {
  //     let allAccount = [];
  //     let totalAccount=[]
  //     const res = await API.graphql(graphqlOperation(listAccountMasterv2Custom));
  //     if (res.data.listAccountMasterv2 !== null) {
  //       setLedger(res.data.listAccountMasterv2);
  //       res.data.listAccountMasterv2.map((ele) => {
  //         let groupName = ele.AccountGroupName.replace(/([a-z])([A-Z])/g, '$1 $2')?.trim()
  //         totalAccount.push({
  //           label: ele.AccountName,
  //           value: ele.AccountsID,
  //           groupName
  //         })
  //         if (accountType === "Sales") {
  //           if (ele.AccountGroupID === 19 || ele.AccountGroupID === 22) {
  //             allAccount.push({
  //               label: ele.AccountName,
  //               value: ele.AccountsID,
  //               groupName
  //             });
  //           }
  //         } else {
  //           if (ele.AccountGroupID === 21 || ele.AccountGroupID === 23) {
  //             allAccount.push({
  //               label: ele.AccountName,
  //               value: ele.AccountsID,
  //               groupName
  //             });
  //           }
  //         }
  //       });
  //       if(setAccNames){
  //         setAccNames(totalAccount)
  //       }
  //       setAllAccount(allAccount);
  //     }
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // }

  const { data: groupsList, isLoading, isError } = useListGroupMasterQuery();

  const { data: ledgerList } = useListAccountMasterv2Query();
  async function listLedgerData() {
    try {
      let allAccount = [];
      let totalAccount = [];

      let res = { data: { listAccountMasterv2: ledgerList } };
      if (ledgerList !== null) {
        setLedger(ledgerList);
        ledgerList.map((ele) => {
          let groupName = ele.accountgroupname
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            ?.trim();
          totalAccount.push({
            label: ele.accountname,
            value: ele.accountsid,
            groupName,
          });
        });
        if (accountType === "Sales") {
          const filteredArray = ledgerList.filter((item) => {
            return comparePathWithId(item.path, 19, 22);
          });
          filteredArray.map((ele) => {
            let groupName = ele.accountgroupname
              .replace(/([a-z])([A-Z])/g, "$1 $2")
              ?.trim();
            allAccount.push({
              label: ele.accountname,
              value: ele.accountsid,
              groupName,
            });
          });
        } else {
          const filteredArray = ledgerList.filter((item) => {
            return comparePathWithId(item.path, 21, 23);
          });
          filteredArray.map((ele) => {
            let groupName = ele.accountgroupname
              .replace(/([a-z])([A-Z])/g, "$1 $2")
              ?.trim();
            if (ele.accountsid !== 41) {
              allAccount.push({
                label: ele.accountname,
                value: ele.accountsid,
                groupName,
              });
            }
          });
        }

        if (setAccNames) {
          setAccNames(totalAccount);
        }
        setAllAccount(allAccount);
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  const companyDetails = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  async function listGroup() {
    // const res = await API.graphql(
    //   graphqlOperation(listAccountGroupMasterCustom)
    // );

    let res = { data: { listAccountGroupMaster: groupsList } };

    if (res.data.listAccountGroupMaster != null) {
      let allAccounts = [];
      let groupName = { label: "", value: "", accountTypeCD: "" };

      res.data.listAccountGroupMaster.map((ele) => {
        if (accountType === "Sales") {
          if 
          // (ele.accountgroupid === 19 || ele.accountgroupid === 22) 
          ([19, 22].some((id) => ele.path.includes(`/${id}/`)))
            {
            allAccounts.push({
              label: ele.accountgroupname,
              value: ele.accountgroupid,
              accountTypeCD: ele.accounttypecd,
            });
          }
        } else {
          if 
          // (ele.accountgroupid === 21 || ele.accountgroupid === 23) 
          ([21,23].some((id) => ele.path.includes(`/${id}/`)))
            {
            allAccounts.push({
              label: ele.accountgroupname,
              value: ele.accountgroupid,
              accountTypeCD: ele.accounttypecd,
            });
          }
        }
        // if (accountType === "Sales") {
        //   if 
        //   (ele.accountgroupid === 19)
        //   // ([19].some((id) => ele.accountgroupid.includes(`/${id}/`)))
        //      {
        //     groupName = {
        //       label: ele.accountgroupname,
        //       value: ele.accountgroupid,
        //       accountTypeCD: ele.accounttypecd,
        //     };
        //   }
        // }
        // if (accountType === "Purchase") {
        //   if
        //    (ele.accountgroupid === 21) 
        //   // ([21].some((id) => ele.accountgroupid.includes(`/${id}/`)))
        //     {
        //     groupName = {
        //       label: ele.accountgroupname,
        //       value: ele.accountgroupid,
        //       accountTypeCD: ele.accounttypecd,
        //     };
        //   }
        // }
      });
      // setState((prev) => ({
      //   ...prev,
      //   group: groupName,
      // }));
      setGroup(allAccounts);
    }
  }
  // async function searchSACItem(value, limit) {
  //   try {
  //     let arrHsn = [];
  //     if (iniHSN.length == 0) {
  //       const res = await API.graphql(
  //         graphqlOperation(searchHSN, {
  //           rowfrom: 0,
  //           limitno: limit !== undefined ? limit : 10000,
  //           word: value,
  //         })
  //       );
  //       let hsnObj = { label: "", value: "" };
  //       let arr = [];
  //       if (res.data.searchHSN !== null) {
  //         await Promise.all(
  //           res.data.searchHSN.map((item) => {
  //             arr.push({
  //               label: `${item.hsnsaccode} - ${item.description}`,
  //               value: `${item.hsnsaccode}`,
  //             });
  //             if (Number(item.hsnsaccode) === Number(value)) {
  //               hsnObj = {
  //                 label: `${item.hsnsaccode} - ${item.description}`,
  //                 value: `${item.hsnsaccode}`,
  //               };
  //             }
  //           })
  //         );
  //       }
  //       if (hsnObj.label === "" && value !== 0) {
  //         hsnObj = {
  //           label: value,
  //           value: value,
  //         };
  //       }
  //       setIniHSN(arrHsn);
  //       setFilterHSN(arr);
  //       return { hsnObj, arr };
  //     }
  //     setFilterHSN([...new Set(iniHSN)]);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  // const handleSearch = useCallback(
  //   debounce((searchValue) => {
  //     searchSACItem(searchValue);
  //   }, 500),
  //   []
  // );
  async function saveChanges() {
    const { group, name } = state;
    const formData = {
      group,
      name,
    };
    if (formValidation(formData)) {
      setLoading(true);
      const LedgerData = {
        accountgroupid: group.value,
        accountname: name,
        accounttypecd: accountTypeCD,
        hsnsaccode: state.hsnCode.value == "" ? 0 : Number(state.hsnCode.value),
      };
      saveNewAccounts(LedgerData);
    }
  }
  async function saveNewAccounts(data) {
    try {
      // const resledger = await API.graphql(
      //   graphqlOperation(createAccountMaster, {
      //     createAccountMasterInput: data,
      //   })
      // );
      const resledger = await createAccountMaster({
        createAccountMasterInput: data,
      });

      if (resledger.data !== null) {
        if (accountType === "Sales") {
          setData((prev) => ({
            ...prev,
            salesAccount: {
              label: resledger?.data?.accountname,
              value: resledger?.data?.accountsid,
            },
          }));
        } else {
          setData((prev) => ({
            ...prev,
            purchaseAccount: {
              label: resledger?.data?.accountname,
              value: resledger?.data?.accountsid,
            },
          }));
        }
        if (setNewAccID) {
          setNewAccID(resledger?.data?.accountsid);
        }
        saveGstDetails(resledger?.data?.accountsid);
        dispatch(dashboardApi.util.invalidateTags(['dashboard']));
        showSuccessSnackbar("Account created Successfully");
        handleClose();
        setLoading(false);
        setOpen(false);
      } else {
        showSuccessSnackbar(resledger?.data?.statusmessage);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  async function saveGstDetails(accID) {
    try {
      const gstData = {
        accountid: accID,
        effectivedate: Math.floor(new Date().getTime() / 1000),
        expireddate: 0,
        gstcompensationtype: state.cessType,
        gstrate: Number(state.gstrate),
        hsnid: String(state.hsnCode.value == "" ? 0 : Number(state.hsnCode.value)),
        cessamount: state.cess == "" ? 0 : Number(state.cess),
      };
      const resGstData = await API.graphql(
        graphqlOperation(createAccountGSTDetails, {
          createAccountGSTDetailsInput: gstData,
        })
      );
    } catch (error) {
      console.log(error);
    }
  }

  // useEffect(() => {
  //   if (
  //     open &&
  //     filterHSN.length == 0 &&
  //     companyDetails?.relatedCompanyDetailsNew?.registrationtype !== 1
  //   )
  //     searchSACItem(0, 10);
  // }, [open]);
  function handleGroupChanges(newValue){
     if (newValue.value === "") {
                        setState((prev) => ({
                          ...prev,
                          group: newValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            group: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            group: "Group  Field is required",
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          group: newValue,
                          errorStatus: {
                            ...prev.errorStatus,
                            group: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            group: "",
                          },
                        }));
                        setAccountTypeCD(newValue?.accountTypeCD);
                      }
  }
  useEffect(() => {
    if (groupsList) {
      listGroup();
    }
  }, [groupsList, open]);
  useEffect(() => {
    if (ledgerList) {
      listLedgerData();
    }
  }, [ledgerList, open]);
  useEffect(()=>{
    setState((prev)=>({
      ...prev,
          group:accountType==="Purchase"?  {label: "Purchases", value: 21, accountTypeCD: "PandL" }:{label: "Sales", value: 19, accountTypeCD: "PandL" },
    }));
  },[accountType]);
  useSaveModalShortcut(saveChanges);
  return (
    <Box id={open ? "AddItemsAccountModal" : ""}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        onClose={handleClose}
      >
        <Fade in={open}>
          <Paper sx={style}>
            <Box
              sx={{
                backgroundColor: "primary.main",
                padding: "5px 15px",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    color: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {accountType === "Sales"
                    ? "Add Sales Account"
                    : "Add Purchase Account"}
                  <IconButton aria-label="delete" onClick={handleClose}>
                    <CloseIcon sx={{ color: "#fff" }} />
                  </IconButton>
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                padding: { xs: "5px", sm: "15px" },
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <InputField
                    required={true}
                    state={state}
                    maxLength={100}
                    name="name"
                    placeholder="Account"
                    size="small"
                    accountType="text"
                    value={state.name}
                    onBlur={() => {
                      setState((prev) => ({
                        ...prev,
                        name: prev.name?.replace(/\s+/g, " ")?.trim(),
                      }));
                    }}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setState((prev) => ({
                          ...prev,
                          name: e.target.value,
                          errorFields: {
                            name: "Account Name is required",
                          },
                          errorStatus: {
                            name: true,
                          },
                        }));
                      } else {
                        let isvalid = true;
                        ledger.map((item) => {
                          if (
                            item?.accountname.toLowerCase() ==
                            e.target.value.toLowerCase()
                          ) {
                            isvalid = false;
                          }
                        });
                        if (isvalid == false) {
                          setState((prev) => ({
                            ...prev,
                            name: e.target.value,
                            errorFields: {
                              name: "Account Name already exists",
                            },
                            errorStatus: {
                              name: true,
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            name: e.target.value,
                            errorFields: {
                              name: "",
                            },
                            errorStatus: {
                              name: false,
                            },
                          }));
                        }
                      }
                    }}
                  />
                </Box>
                <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                  <Autocomplete
                    disablePortal
                    id="group"
                    disableClearable
                     options={[{ label: "Add New Group", value: "add_new" }, ...group]}
                    isOptionEqualToValue={(option, value) =>
                      option.value == value.value
                    }
                    value={state.group}
                    onChange={(e, newValue) => {
                           if (newValue?.value === "add_new") {
    e.stopPropagation(); 
    setOpenGroupModal(true); 
    return;
  }
                      // if (newValue.value === "") {
                      //   setState((prev) => ({
                      //     ...prev,
                      //     group: newValue,
                      //     errorStatus: {
                      //       ...prev.errorStatus,
                      //       group: true,
                      //     },
                      //     errorFields: {
                      //       ...prev.errorFields,
                      //       group: "Group  Field is required",
                      //     },
                      //   }));
                      // } else {
                      //   setState((prev) => ({
                      //     ...prev,
                      //     group: newValue,
                      //     errorStatus: {
                      //       ...prev.errorStatus,
                      //       group: false,
                      //     },
                      //     errorFields: {
                      //       ...prev.errorFields,
                      //       group: "",
                      //     },
                      //   }));
                      //   setAccountTypeCD(newValue?.accountTypeCD);
                      // }
                      handleGroupChanges(newValue);
                    }}
                    sx={{
                      ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                      {
                        paddingBottom: "5px",
                      },
                      ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                      {
                        paddingTop: "6px",
                        paddingBottom: "5px",
                        paddingLeft: "6px",
                      },
                    }}
                    size="small"
                    renderOption={(props, option) =>
                        option.value === "add_new" ? (
                          <MenuItem {...props}>
                            <ListItemIcon  sx={{ color: 'primary.main' }}>
                              <AddBox fontSize="small" />
                            </ListItemIcon>
                            <ListItemText  sx={{ color: 'primary.main' }} primary="Add New Group" />
                          </MenuItem>
                        ) : (
                          <MenuItem {...props}>{option.label}</MenuItem>
                        )
                      }
                    renderInput={(params) => (
                      <TextField
                        error={state.errorStatus.group === true ? true : false}
                        sx={{
                          ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                          {
                            padding: "8.5px 7px",
                          },
                          ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                          {
                            fontSize: "14px",
                          },
                          label: {
                            fontSize: "14px",
                          },
                          ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                            fontSize: "14px",
                          },
                          ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                            color: "input.font",
                          },
                          ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            borderColor: "input.border",
                          },
                          ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                            color: "input.font",
                          },
                          ".css-14qz1ij-MuiListItemText-root": {
                            margin: "0px",
                          },
                          ".css-wgai2y-MuiFormLabel-asterisk": {
                            color: "danger.main",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        {...params}
                        label="Group"
                      />
                    )}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state?.errorFields.group}
                  </Typography>
                </Box>
              </Box>

              {state.group.value !== 17 &&
                state.group.value !== 16 &&
                companyDetails?.relatedcompanydetailsnew?.[0]
                  ?.registrationtype !== 1 && (
                  <Accordion sx={{ mt: 2 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      sx={{ maxHeight: "auto" }}
                    >
                      <Typography
                        sx={{ color: "primary.main", fontWeight: "500" }}
                      >
                        GST Details
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box sx={{ display: "flex" }}>
                        <Box
                          sx={{
                            flex: { xs: 1, sm: 0.5 },
                            m: 1,
                            minWidth: "10px",
                          }}
                        >
                          <Autocomplete
                            openOnFocus
                            error={
                              state.errorStatus.hsnCode === true ? true : false
                            }
                            disablePortal
                            id="SAC CODE"
                            name="hsnCode"
                            placeholder="HSN/SAC Code"
                            disableClearable
                            options={["Add SAC Code", ...filterHSN]}
                            isOptionEqualToValue={(option, value) =>
                              option.value == value.value
                            }
                            value={state.hsnCode}
                            onChange={(e, newValue) => {
                              if (newValue == "") {
                                setState((prev) => ({
                                  ...prev,
                                  hsnCode: newValue,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    hsnCode: true,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    hsnCode: "SAC Code is required",
                                  },
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  hsnCode: newValue,
                                  errorStatus: {
                                    ...prev.errorStatus,
                                    hsnCode: true,
                                  },
                                  errorFields: {
                                    ...prev.errorFields,
                                    hsnCode: "",
                                  },
                                }));
                              }
                            }}
                            sx={{
                              ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                              {
                                paddingBottom: "5px",
                              },
                              ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                              {
                                paddingTop: "6px",
                                paddingBottom: "5px",
                                paddingLeft: "6px",
                              },
                            }}
                            onInputChange={(e, newValue) => {
                              setRow(0);
                              if (newValue) {
                                searchHSNDetails(newValue, 0, 20);
                              } else {
                                searchHSNDetails("", 0, 20);
                              }
                            }}
                            ListboxProps={HSNListboxProps}
                            size="small"
                            renderInput={(params) => (
                              <TextField
                                
                                sx={{
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                  {
                                    padding: "8.5px 7px",
                                  },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                  {
                                    fontSize: "14px",
                                  },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                  {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                  {
                                    color: "input.font",
                                  },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "input.border",
                                  },
                                  ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                  {
                                    color: "input.font",
                                  },
                                  ".css-14qz1ij-MuiListItemText-root": {
                                    margin: "0px",
                                  },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                {...params}
                                label="HSN/SAC Code"
                              />
                            )}
                            renderOption={(props, option) => (
                              <>
                                {option === "Add SAC Code" ? (
                                  <MenuItem
                                    value={"addHsn"}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      event.preventDefault();
                                      setOpenHsnModal(true);
                                    }}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      position: "sticky",
                                      top: "-8px",
                                      backgroundColor: grey[50],
                                      "&:hover": {
                                        backgroundColor: grey[200],
                                      },
                                    }}
                                  >
                                    <AddBox
                                      fontSize="small"
                                      sx={{
                                        marginRight: "5px",
                                        color: "primary.main",
                                      }}
                                    />
                                    <ListItemText
                                      sx={{ color: "primary.main" }}
                                      primary={"Add HSN/SAC Code"}
                                    />
                                  </MenuItem>
                                ) : (
                                  <li {...props}>{option.label}</li>
                                  // <MenuItem
                                  //   {...props}
                                  //   key={option.value}
                                  //   value={option.value}
                                  // >
                                  //   <ListItemText primary={option.label} />
                                  // </MenuItem>
                                )}
                              </>
                            )}
                          />
                          {searchValue < 3 &&
                            state.errorStatus.hsnCode !== true ? (
                            <Typography
                              sx={{
                                marginTop: "2px",
                                marginLeft: "10px",
                                marginBottom: "0px",
                                fontSize: "11px",
                                color: "primary.main",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Use atleast 3 characters
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                marginTop: "2px",
                                marginLeft: "10px",
                                marginBottom: "0px",
                                fontSize: "11px",
                                color: "danger.main",
                              }}
                            >
                              {state?.errorFields.hsnCode}
                            </Typography>
                          )}
                        </Box>
                        <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                          <TextField
                            error={
                              state.errorStatus.gstrate === true ? true : false
                            }
                            select
                            name="gstrate"
                            label="GST Rate"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={state.gstrate}
                            onChange={(e) => {
                              const name = e.target.name;
                              const value = e.target.value;

                              if (value != "addgstrate") {
                                if (value === "") {
                                  setState((prev) => ({
                                    ...prev,
                                    gstrate: value,
                                    errorStatus: {
                                      ...prev.errorStatus,
                                      gstrate: true,
                                    },
                                    errorFields: {
                                      ...prev.errorFields,
                                      gstrate: "GST Rate is required",
                                    },
                                  }));
                                } else {
                                  setState((prev) => ({
                                    ...prev,
                                    gstrate: value,
                                    errorStatus: {
                                      ...prev.errorStatus,
                                      gstrate: false,
                                    },
                                    errorFields: {
                                      ...prev.errorFields,
                                      gstrate: "",
                                    },
                                  }));
                                }
                              }
                            }}
                            sx={{
                              ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                              {
                                fontSize: "14px",
                              },
                              label: {
                                fontSize: "14px",
                              },
                              ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                              {
                                fontSize: "14px",
                              },
                              ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                              {
                                color: "input.font",
                              },
                              ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                                borderColor: "input.border",
                              },
                              ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                              {
                                color: "input.font",
                              },
                              ".css-wgai2y-MuiFormLabel-asterisk": {
                                color: "danger.main",
                              },
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          >
                            {[
                              { id: 0, rate: "0%" },
                              { id: 5, rate: "5%" },
                              { id: 12, rate: "12%" },
                              { id: 18, rate: "18%" },
                              { id: 28, rate: "28%" },
                            ]?.map((item, ind) => {
                              return (
                                <MenuItem key={item.id} value={`${item.id}`}>
                                  <ListItemText
                                    sx={{ margin: "0px" }}
                                    primary={item.rate}
                                  />
                                </MenuItem>
                              );
                            })}
                            <MenuItem value={"addgstrate"}>
                              <SettingsIcon
                                fontSize="small"
                                sx={{ marginRight: "5px" }}
                              />
                              <ListItemText primary={"Add GST Rate"} />
                            </MenuItem>
                          </TextField>
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "danger.main",
                            }}
                          >
                            {state?.errorFields.gstrate}
                          </Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                          <Box
                            sx={{
                              position: "relative",
                              border: "solid 1px",
                              borderColor:
                                state.errorStatus.cessType === true
                                  ? "danger.main"
                                  : "input.border",
                              borderRadius: "4px",
                              padding: "10px 14px",
                              ".css-ahj2mt-MuiTypography-root": {
                                fontSize: "12px",
                                color: "input.font",
                              },
                              ".css-1n70hd2-MuiButtonBase-root-MuiRadio-root": {
                                padding: "0px",
                                margin: "0px 5px",
                              },
                              ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root": {
                                padding: "0px",
                                margin: "0px 5px",
                                color: "input.border",
                              },
                              ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root.Mui-checked":
                              {
                                color: "primary.main",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: { xs: "" },
                                letterSpacing: "0.00938em",
                                position: "absolute",
                                top: "-10px",
                                left: "9px",
                                width: "100%",
                                // background: "#fff",
                                background: theme?.palette?.TmId.id
                                  .toString()
                                  .includes("9")
                                  ? "#1E1E1E"
                                  : "#fff",
                                padding: "0px 3px",
                                color:
                                  state.errorStatus.cessType === true
                                    ? "danger.main"
                                    : "input.font",
                              }}
                            >
                              {isSmallDvce
                                ? `Cess Type${" "}`
                                : `GST compensation Cess Type${" "}`}
                              <span style={{ color: "#e55353" }}>*</span>
                            </Typography>

                            <RadioGroup
                              sx={{
                                display: "flex",
                                flexDirection: { xs: "row", sm: "row" },
                              }}
                              name="cessType"
                              value={state.cessType}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "") {
                                  setState((prev) => ({
                                    ...prev,
                                    cessType: value,

                                    errorStatus: {
                                      ...prev.errorStatus,
                                      cessType: true,
                                    },
                                    errorFields: {
                                      ...prev.errorFields,
                                      cessType:
                                        "Please Select GST Compensation  Type",
                                    },
                                  }));
                                } else {
                                  setState((prev) => ({
                                    ...prev,
                                    cessType: value,
                                    errorStatus: {
                                      ...prev.errorStatus,
                                      cessType: false,
                                    },
                                    errorFields: {
                                      ...prev.errorFields,
                                      cessType: "",
                                    },
                                  }));
                                }
                              }}
                            >
                              <FormControlLabel
                                value="Percentage"
                                control={<Radio size="small" disableRipple />}
                                label="Percentage"
                              />
                              <FormControlLabel
                                value="Amount"
                                control={<Radio size="small" />}
                                label="Amount"
                              />
                            </RadioGroup>
                          </Box>
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "danger.main",
                            }}
                          >
                            {state.errorFields.cessType}
                          </Typography>
                        </Box>
                        <Box sx={{ flex: { xs: 1, sm: 0.5 }, m: 1 }}>
                          <TextField
                            error={
                              state.errorStatus.cess == true ? true : false
                            }
                            label="Cess"
                            name="cess"
                            id="Cess"
                            value={state.cess}
                            fullWidth
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value !== "") {
                                setState((prev) => ({
                                  ...prev,
                                  cess: value,
                                }));
                              } else {
                                setState((prev) => ({
                                  ...prev,
                                  cess: "",
                                }));
                              }
                            }}
                            size="small"
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  {state.cessType == "Percentage" ? "%" : "₹"}
                                </InputAdornment>
                              ),
                            }}
                            sx={{
                              ".css-wgai2y-MuiFormLabel-asterisk": {
                                color: "danger.main",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "0px",
                              fontSize: "11px",
                              color: "danger.main",
                            }}
                          >
                            {state?.errorFields.cess}
                          </Typography>
                        </Box>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                )}
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                // flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Button
                onClick={handleClose}
                variant="outlined"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                Cancel
              </Button>
              <LoadingButton
                loading={loading}
                disableRipple={true}
                onClick={saveChanges}
                variant="contained"
                sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
              >
                ADD
              </LoadingButton>
            </Box>
          </Paper>
        </Fade>
      </Modal>
      {openHsnModal === true && (
        <AddHSNModal
          open={openHsnModal}
          setOpen={setOpenHsnModal}
          setData={setState}
          data={state}
          setFilterHSN={setFilterHSN}
          filteredHSN={filterHSN}
          searchHSNSAC={() => searchHSNDetails("", 0, 20)}
          hsnParamsID={""}
          itemType={"ledger"}
          page={"ledger"}
        />
      )}
      <GroupModal open={openGroupModal}
             onClose={()=>setOpenGroupModal(false)}
             parentGroupOptions={group}
             onSave={(newValue)=>handleGroupChanges(newValue)}
            />
    </Box>
  );
}

export default AddItemsAccountModal;
